import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import './ProjectCard.css';

const ProjectCard = ({ project, delay = 0 }) => {
  return (
    <div className="project-card" data-aos="fade-up" data-aos-delay={delay}>
      <div className="project-image">
        {project.image ? (
          <img src={project.image} alt={project.title} />
        ) : (
          <div className="project-image-placeholder">
            {project.title.charAt(0)}
          </div>
        )}
        <div className="project-overlay">
          <Link to={`/projects/${project.slug}`} className="project-link">
            View Details
          </Link>
        </div>
      </div>
      <div className="project-content">
        <h3>{project.title}</h3>
        <p>{project.description}</p>
        <div className="project-tech">
          {project.tech_list?.map((tech, index) => (
            <span key={index} className="tech-tag">{tech}</span>
          ))}
        </div>
        <div className="project-actions">
          {project.live_url && (
            <a href={project.live_url} target="_blank" rel="noopener noreferrer" className="project-action">
              <FaExternalLinkAlt /> Live
            </a>
          )}
          {project.github_url && (
            <a href={project.github_url} target="_blank" rel="noopener noreferrer" className="project-action">
              <FaGithub /> Code
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;